
export interface AgentCommand {
    id: string;
    label: string;
    description?: string;
}

export interface AgentCommandCategory {
    category: string;
    commands: AgentCommand[];
}

export const AGENT_COMMANDS: AgentCommandCategory[] = [
    {
        category: "Agents (Personas)",
        commands: [
            { id: "/superengineer:core:agents:superengineer-master", label: "SuperEngineer Master", description: "The core orchestrator" },
            { id: "/superengineer:se:agents:analyst", label: "Analyst", description: "Business and data analysis expert" },
            { id: "/superengineer:se:agents:architect", label: "Architect", description: "System design and technical architecture" },
            { id: "/superengineer:se:agents:dev", label: "Developer", description: "Code implementation expert" },
            { id: "/superengineer:se:agents:pm", label: "Product Manager", description: "Roadmap and requirement expert" },
            { id: "/superengineer:se:agents:sm", label: "Scrum Master", description: "Agile process facilitator" },
            { id: "/superengineer:se:agents:tea", label: "Test Engineer", description: "Quality and testing expert" },
            { id: "/superengineer:se:agents:tech-writer", label: "Tech Writer", description: "Documentation specialist" },
            { id: "/superengineer:se:agents:ux-designer", label: "UX Designer", description: "User experience and interface expert" },
            { id: "/superengineer:se:agents:quick-flow-solo-dev", label: "Quick Flow Solo Dev", description: "Rapid end-to-end development" },
        ]
    },
    {
        category: "Discovery & Planning",
        commands: [
            { id: "/superengineer:se:workflows:workflow-init", label: "Init Workflow", description: "Initialize a new SE project workflow" },
            { id: "/superengineer:se:workflows:create-product-brief", label: "Create Product Brief", description: "Collaborative discovery for core app idea" },
            { id: "/superengineer:se:workflows:research", label: "Conduct Research", description: "Market, Technical, or Domain research" },
            { id: "/superengineer:se:workflows:create-ux-design", label: "Plan UX Design", description: "UX patterns, look and feel planning" },
            { id: "/superengineer:se:workflows:create-architecture", label: "Design Architecture", description: "System design and technology decisions" },
            { id: "/superengineer:se:workflows:prd", label: "Generate PRD", description: "Create, Validate, or Edit PRDs" },
            { id: "/superengineer:se:workflows:create-epics-and-stories", label: "Create Stories", description: "Transform PRD into actionable epics/stories" },
        ]
    },
    {
        category: "Implementation & Quality",
        commands: [
            { id: "/superengineer:se:workflows:sprint-planning", label: "Sprint Planning", description: "Manage project implementation phase" },
            { id: "/superengineer:se:workflows:dev-story", label: "Execute Story", description: "Implement tasks, write tests, and validate" },
            { id: "/superengineer:se:workflows:code-review", label: "Code Review", description: "In-depth adversarial code review" },
            { id: "/superengineer:se:workflows:correct-course", label: "Correct Course", description: "Handle significant changes mid-sprint" },
            { id: "/superengineer:se:workflows:retrospective", label: "Run Retrospective", description: "Review success and extract lessons" },
        ]
    },
    {
        category: "Testing (TestArch)",
        commands: [
            { id: "/superengineer:se:workflows:testarch-atdd", label: "TDD Acceptance", description: "Generate failing tests before implementation" },
            { id: "/superengineer:se:workflows:testarch-automate", label: "Test Automation", description: "Expand post-implementation test coverage" },
            { id: "/superengineer:se:workflows:testarch-ci", label: "Scaffold CI/CD", description: "Initialize quality pipelines" },
            { id: "/superengineer:se:workflows:testarch-framework", label: "Test Framework", description: "Init Playwright/Cypress framework" },
            { id: "/superengineer:se:workflows:testarch-nfr", label: "Non-Functional", description: "Performance, security, reliability" },
            { id: "/superengineer:se:workflows:testarch-test-design", label: "Test Strategy", description: "System and Epic level test planning" },
            { id: "/superengineer:se:workflows:testarch-test-review", label: "Test Review", description: "Review test suite quality" },
            { id: "/superengineer:se:workflows:testarch-trace", label: "Traceability", description: "Requirements-to-tests matrix" },
        ]
    },
    {
        category: "Utilities & Diagrams",
        commands: [
            { id: "/superengineer:se:workflows:create-excalidraw-diagram", label: "System Diagram", description: "Architecture, ERD, UML" },
            { id: "/superengineer:se:workflows:create-excalidraw-dataflow", label: "Data Flow (DFD)", description: "Visualize data movement" },
            { id: "/superengineer:se:workflows:create-excalidraw-flowchart", label: "Flowchart", description: "Process and logic visualization" },
            { id: "/superengineer:se:workflows:create-excalidraw-wireframe", label: "Wireframe", description: "UI layout and planning" },
            { id: "/superengineer:se:workflows:workflow-status", label: "Check Status", description: "What should I do now?" },
            { id: "/superengineer:se:workflows:sprint-status", label: "Sprint Status", description: "Summarize status and risks" },
            { id: "/superengineer:se:workflows:document-project", label: "Document Project", description: "Analyze brownfield projects" },
            { id: "/superengineer:se:workflows:generate-project-context", label: "Project Context", description: "Create core rules and patterns" },
            { id: "/superengineer:core:workflows:party-mode", label: "Party Mode", description: "Multi-agent brainstorming" },
            { id: "/superengineer:core:tasks:shard-doc", label: "Shard Docs", description: "Split large markdown files" },
            { id: "/superengineer:core:tasks:index-docs", label: "Index Docs", description: "Generate project index" },
        ]
    }
];
